import { GridColTypeDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Box, Chip, Tooltip } from "@mui/material";

import baseColumn from "./BaseColumn";
import { fieldLabelFormat } from "../TableUtils";

export interface ChipsOptions {
  headerLabels?: Record<string, string>;
}

function chipsColumn(options?: ChipsOptions): GridColTypeDef {
  const chipsColumn: GridColTypeDef = {
    ...baseColumn,
    type: "chips",
    renderCell: (params: GridRenderCellParams) => {
      const values: Array<string> = params.value;
      return (
        <Box>
          {values.map((value) => {
            return (
              <Tooltip key={value} title={value}>
                <Chip label={value} variant="filled" />
              </Tooltip>
            )
          })}
        </Box>
      )
    }
  };
  if (options?.headerLabels) {
    chipsColumn.renderHeader = fieldLabelFormat(options.headerLabels);
  }
  return chipsColumn;
}

export default chipsColumn;